import Link from "next/link";
import styled from "styled-components";

interface ItemProps {
  $top?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacers.L};
  align-items: center;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Message = styled.h2`
  ${({ theme }) => theme.typography.SmallHeadline};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  text-align: center;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacers.XL};
`;

export const Details = styled.p`
  ${({ theme }) => theme.typography.RegularParagraph};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  text-align: center;
`;

export const DetailsLink = styled(Link)`
  position: relative;
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  text-decoration: underline;
  text-underline-offset: 4px;
`;

export const Code = styled.p<ItemProps>`
  ${({ $top, theme }) => `
    ${$top ? theme.typography.SmallParagraphBold : theme.typography.RegularParagraph};
    font-weight: ${$top ? theme.typography.SmallParagraphBold.fontWeight : theme.typography.RegularParagraph.fontWeight};
    color: ${$top ? theme.colors.text.darkerGrey : theme.colors.text.baseGrey};
  `}
  text-align: center;
`;
